import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { deleteMeNotifications, putAllNotifications, putMeNotifications } from '@/api/calls/me/me.api';
import { displayGenericErrorToaster } from '@/api/helpers/helpers';
import type { NotificationStatus } from '@/types/notifications/notification';

export function useDeleteNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuids: string[]) => deleteMeNotifications(uuids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getMeNotifications'] });
    },
    onError: () => displayGenericErrorToaster()
  });
}
export function useUpdateNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ uuids, status }: { uuids: string[]; status: NotificationStatus }) =>
      putMeNotifications(uuids, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getMeNotifications'] });
    },
    onError: () => displayGenericErrorToaster()
  });
}

export function useUpdateAllNotifications() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (status: NotificationStatus | undefined = 'read') => putAllNotifications(status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getMeNotifications'] });
    },
    onError: () => displayGenericErrorToaster()
  });
}
